import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent {

  constructor(
    private router: Router,
    public afAuth: AngularFireAuth
   ) { }

  logout() {
    this.afAuth.auth.signOut();
    this.router.navigate(['/home']);
  }

}



// WEBPACK FOOTER //
// /Users/traev/Sites/btt/src/app/components/logout/logout.component.ts